import React from 'react';

const Question = ({
  color = '#B8BABF',
  size = 32,
}: {
  color?: string;
  size?: number;
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 32 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M11.9339 27.5295C8.23068 26.6608 5.33916 23.7693 4.4705 20.0661C3.84317 17.3917 3.84317 14.6083 4.4705 11.9339C5.33916 8.23068 8.23068 5.33916 11.9339 4.4705C14.6083 3.84317 17.3917 3.84317 20.0661 4.4705C23.7693 5.33916 26.6608 8.23068 27.5295 11.9339C28.1568 14.6083 28.1568 17.3917 27.5295 20.0661C26.6608 23.7693 23.7693 26.6608 20.0661 27.5295C17.3917 28.1568 14.6083 28.1568 11.9339 27.5295Z'
        stroke={color}
        strokeWidth='2'
      />
      <circle cx='16' cy='20.6666' r='1.33333' fill={color} />
      <path
        d='M13.3334 13.3333V12.6667C13.3334 11.1939 14.5273 10 16 10V10V10C17.4728 10 18.6667 11.1939 18.6667 12.6667V12.8284C18.6667 13.5786 18.3687 14.298 17.8383 14.8284L16 16.6667'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default Question;
